<template>
  <div class="home data-panel-home">
    <Header title="绑定账号"></Header>
    <div
      class="wechat-home"
      v-if="emails && emails.length"
    >
      <div class="email-item">
        已绑定账号
        <div class="wechat-device-info">
          <el-table
            v-if="emails && emails.length"
            :data="emails"
            stripe
            style="width: 100%"
            align='center'
          >
            <el-table-column
              label="账号"
              align='center'
            >
              <template slot-scope="scope">
                <div class="">
                  {{scope.row}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              align='center'
            >
              <template slot-scope="scope">
                <div class="">
                  <!-- 解绑 -->
                  <button
                    class="unbind-button wechat-unbind-button"
                    type="danger"
                    :unbindEmail="scope.row"
                    @click="checkUnBind(scope.row)"
                  >解绑</button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

    </div>
    <div
      v-else
      class="wechat-home"
    >
      <div>还没有绑定账号</div>
    </div>
    <!-- 解绑dialog -->
    <el-dialog
      title="提示"
      :visible.sync="showUnbindDialog"
      width="80%"
    >
      <span>确认解绑？</span>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="showUnbindDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="unbndEmail"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import Header from "@/WechatComponents/Header.vue";
const WECHAT_HOST = "https://open.weixin.qq.com/connect/oauth2/authorize";
import { getCookie } from "@/utils/utils";
import { Message } from "element-ui";

export default {
  name: "home",
  components: {
    Header
  },
  data() {
    return {
      email: "",
      unbindEmail: "",
      showUnbindDialog: false
    };
  },
  computed: mapState({
    openid: state => state.wechat.openid,
    emails: state => state.wechat.emails
  }),
  created() {
    try {
      let that = this;
      let openid = getCookie("openid") || this.$route.query.openid;

      let redirect_url =
        this.$route.query.redirect_url ||
        "https%3a%2f%2fconsole.bonuscloud.work%2fwechat%2funbind";
      let appid = this.$route.query.appid || "wx95ccc89810c1da7f";
      let code = this.$route.query.code;
      // alert("search", window.location.search);
      // alert("href", window.location.href);

      if (openid || code) {
        this.openId = openid;

        this.getWechatInfo({ openid, code });
      } else {
        // window.location.href = "http://127.0.0.1:8080/wechat/unbind?code=051jslGa1e89uD0UAlGa1x2l3B4jslGS&state=123"
        window.location.href = `${WECHAT_HOST}?appid=${appid}&redirect_uri=${redirect_url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
      }
    } catch (error) {
      alert(error);
    }
  },
  methods: {
    ...mapActions(["getWechatInfo", "unBindWechatEmail"]),
    checkUnBind(email) {
      this.showUnbindDialog = true;
      this.unbindEmail = email;
    },
    unbndEmail() {
      this.showUnbindDialog = false;
      let { openid, unbindEmail } = this;

      this.unBindWechatEmail({ openid, email: unbindEmail }).then(res => {
        if (res.code === 200) {
          // 刷新硬件列表
          this.getWechatInfo({ openid });
          Message({
            type: "success",
            message: res.message
          });
          // window.location.reload()
        } else {
          Message({
            type: "error",
            message: res.message || "unbind error"
          });
        }
      });
    }
  }
};
</script>

<style lang="stylus">
.data-panel-home.home {
  height: auto !important;
}

.wechat-home {
  background: #fff;
  text-align: center;
  padding: 20px;
}

.bind-email-wrap {
  padding: 30px 20px;
  background: #fff;
  text-align: center;
}

.wechat-bind-email {
  margin: 20px 0;
}

.wechat-bind-email {
  margin-top: 20px;
}

.wechat-page {
  background: #fff;
  height: 100% !important;

  .home {
    height: 100% !important;
  }
}

.wechat-page .tips {
  margin: 60px 0;
  font-size: 12px;
  
}

.wechat-unbind-button{
  width: 60px;
  border-radus: 10px;
}
</style>

